import React, { FC } from 'react';

import { fc } from 'i18n';

import styles from './styles.module.css';

interface IMusteringPanelProps {
  total: number;
  accounted: number;
  outstanding: number;
}

export const MusteringPanel: FC<IMusteringPanelProps> = ({ total, accounted, outstanding }) => {
  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.counter}>
          <div className={styles.title}>{fc('total')}</div>
          <div className={`${styles.count} ${styles.total}`}>{total}</div>
        </div>
        <div className={styles.counter}>
          <div className={styles.title}>{fc('accounted')}</div>
          <div className={`${styles.count} ${styles.accounted}`}>{accounted}</div>
        </div>
        <div className={styles.counter}>
          <div className={styles.title}>{fc('outstanding')}</div>
          <div className={`${styles.count} ${styles.outstanding}`}>{outstanding}</div>
        </div>
      </div>
      <div className={styles.divider} />
    </div>
  );
};
